<div class="multi-loader">
    <svg viewBox="0 0 100 100">
        <circle cx="50" cy="50" r="45" stroke="#111" stroke-width="12" fill="none" opacity="0.3" />
        @if (isClosed) {
            <circle cx="50" cy="50" [attr.r]="radius" stroke="#FF453A" stroke-width="12" fill="none" />
        } @else {
            <circle
                cx="50"
                cy="50"
                [attr.r]="radius"
                stroke="#2CFFB0"
                stroke-width="12"
                fill="none"
                stroke-linecap="round"
                i18n-stroke-linecap
                [attr.stroke-dasharray]="circumference"
                [attr.stroke-dashoffset]="dashOffset"
                style="transform: rotate(-90deg); transform-origin: center"
            />
            <path [attr.d]="yellowPath" stroke="#FFD94A" stroke-width="9" fill="none" stroke-linecap="round" i18n-stroke-linecap />
            <path [attr.d]="orangePath" stroke="#FF8A4A" stroke-width="9" fill="none" stroke-linecap="round" i18n-stroke-linecap />
        }
    </svg>
</div>
